<template>
  <!-- Info icon → click-to-open card (not a hover tooltip: survives long
       content, works on touch). Unknown key renders nothing, so tips are
       safe to sprinkle. Content comes from atlasWorkflowHelp.js — keep
       that module in step with the design docs it distils. -->
  <v-menu
    v-if="entry"
    :close-on-content-click="false"
    offset-y
    max-width="400"
  >
    <template #activator="{ on, attrs }">
      <v-btn icon x-small class="help-tip__btn" tabindex="-1" v-bind="attrs" v-on="on">
        <v-icon small color="grey">mdi-information-outline</v-icon>
      </v-btn>
    </template>
    <v-card class="pa-3" max-width="400">
      <div class="text-subtitle-2 mb-1">{{ entry.title }}</div>
      <div v-if="entry.body" class="text-body-2" :class="{ 'mb-1': entry.bullets }">
        {{ entry.body }}
      </div>
      <ul v-if="entry.bullets" class="text-body-2 pl-4 mb-0">
        <li v-for="(b, i) in entry.bullets" :key="i" class="mb-1">{{ b }}</li>
      </ul>
    </v-card>
  </v-menu>
</template>

<script>
import { WORKFLOW_HELP } from './atlasWorkflowHelp';

export default {
  name: 'HelpTip',
  props: {
    k: { type: String, required: true },
  },
  computed: {
    entry() {
      return WORKFLOW_HELP[this.k] || null;
    },
  },
};
</script>

<style scoped>
/* Sits inline next to labels/controls without stretching the line. */
.help-tip__btn {
  vertical-align: middle;
}
</style>
